import { render } from "./BorderSpinner.vue?vue&type=template&id=25695aa8"
import script from "./BorderSpinner.vue?vue&type=script&lang=js"
export * from "./BorderSpinner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__